import dayjs, { dateTimeDisplayFormat } from '~libs/dayjs';

/**
 * Shared formatter for the collection_date / created_at / invoice_date fields
 * surfaced across the Payment Batches feature (list, detail, invoices modal).
 * Renders falsy values and parse failures as an em-dash so the table never
 * shows a literal "Invalid Date" string for malformed input.
 */
export const formatBatchDate = (value: string | null | undefined): string => {
  if (!value) return '—';
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format(dateTimeDisplayFormat) : '—';
};
